import { render, staticRenderFns } from "./MagicCubePreview.vue?vue&type=template&id=faab2cfc&scoped=true&"
import script from "./MagicCubePreview.vue?vue&type=script&lang=js&"
export * from "./MagicCubePreview.vue?vue&type=script&lang=js&"
import style0 from "./MagicCubePreview.vue?vue&type=style&index=0&id=faab2cfc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faab2cfc",
  null
  
)

export default component.exports